import type { Control, FieldValues } from 'react-hook-form';
import OdinController from '../../dynamic-form/odin-controller.component';
import type { RichTextAreaProps } from './rich-text-area.component';
import RichTextArea from './rich-text-area.component';

export interface HfRichTextAreaProps {
  control: Control<FieldValues>;
  name: string;
}

export default function HfRichTextArea({
  value,
  control,
  name,
  label,
  readOnly,
  required,
  height = 108,
  onChange,
  fieldValueConverter,
  disabled,
  labelStyles,
}: HfRichTextAreaProps & RichTextAreaProps) {
  return (
    <OdinController
      name={name}
      control={control}
      onChange={onChange}
      fieldValueConverter={fieldValueConverter}
      defaultValue={value}
      render={({ field: { ref, onChange, value }, fieldState: { error } }) => (
        <RichTextArea
          inputRef={ref}
          name={name}
          onChange={onChange}
          label={label}
          error={error?.message}
          value={value}
          height={height}
          readOnly={readOnly}
          required={required}
          disabled={disabled}
          labelStyles={labelStyles}
        />
      )}
    />
  );
}
